import type MapBrowserEvent from "ol/MapBrowserEvent";

export const noFeaturePointed = (
  mapBrowserEvent: MapBrowserEvent<any>
): boolean => {
  const map = mapBrowserEvent.map;
  const features = map.getFeaturesAtPixel(mapBrowserEvent.pixel);
  return !features.length;
};
